// Reusable formatting helpers for UI rendering

export function formatDate(val) {
  if (!val) return '';
  if (val instanceof Date) {
    const d = String(val.getDate()).padStart(2, '0');
    const m = String(val.getMonth() + 1).padStart(2, '0');
    const y = String(val.getFullYear());
    return `${d}.${m}.${y}`;
  }
  if (typeof val === 'string') {
    // Normalize ISO-like YYYY-MM-DD to DD.MM.YYYY
    const m = val.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}.${m[2]}.${m[1]}`;
    // Fallback: replace dashes with dots
    return val.replace(/-/g, '.');
  }
  return String(val);
}

// Returns the percentage as a display number (e.g. 87.5) or 0 when total is 0.
export function quizResultPercentage(correct, total) {
  if (!total || total <= 0) return 0;
  return parseFloat(((correct / total) * 100).toFixed(1));
}

// Returns true when the result meets the passing threshold (75%).
export function quizResultPassed(correct, total) {
  if (!total || total <= 0) return false;
  return correct / total >= 0.75;
}

export function formatStatus(val) {
  const map = {
    Activ: 'Activ',
    Rescheduled: 'Reprogramat',
    Inactiv: 'Inactiv',
    Finalized: 'Finalizat',
    Failed: 'Nepromovat',
    Quit: 'Renunțat',
  };
  return map[val] || val || '';
}

export function formatReason(val) {
  const map = {
    Postponing: 'Amanare',
    Interruption: 'Intrerupere',
    Extension: 'Prelungire',
  };
  return map[val] || val || '';
}

export function toDateString(val) {
  if (val instanceof Date) {
    const y = val.getFullYear();
    const m = String(val.getMonth() + 1).padStart(2, '0');
    const d = String(val.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  return val || '';
}

export function toTimeString(val) {
  if (val instanceof Date) {
    const hh = String(val.getHours()).padStart(2, '0');
    const mm = String(val.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }
  return val || '';
}

export function formatDateTime(val) {
  if (!val) return '-';
  const date = new Date(val);
  const formattedDate = formatDate(date);
  const time = date.toLocaleTimeString('ro-RO', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${formattedDate} ${time}`;
}
